<template>
  <div>
    <van-nav-bar
      :title="snInfo.path.name4"
      :left-text="!hideBackBtn ? '返回' : ''"
      :left-arrow="!hideBackBtn"
      :fixed="true"
      @click-left="onClickLeft"
    />
    <van-notice-bar v-show="headText" :scrollable="false">{{
      headText
    }}</van-notice-bar>
    <div class="body">
      <div class="nav">
        更新于:
        {{
          currData.time
            ? moment(currData.time * 1000).format("YYYY-MM-DD HH:mm:ss")
            : "--"
        }}
      </div>
      <van-row
        gutter="10"
        style="max-width: 90%; margin: 10px auto 0px auto; text-align: center"
        v-show="currData.station_param == '六参数'"
      >
        <van-col span="8">
          <div
            @click="tp = 'pm25'"
            class="data_card"
            style="background: #73b973"
            :class="{ active: tp == 'pm25' }"
          >
            <div class="tp">PM2.5</div>
            <div class="data_num">{{ currData.pm25 }}</div>
            <span class="un">ug/m3</span>
          </div>
        </van-col>

        <van-col span="8">
          <div
            @click="tp = 'wind_speed'"
            class="data_card"
            style="background: #006699"
            :class="{ active: tp == 'wind_speed' }"
          >
            <div class="tp">风速</div>
            <div class="data_num">{{ currData.wind_speed | e }}</div>
            <span class="un">m/s</span>
          </div>
        </van-col>

        <van-col span="8">
          <div
            @click="tp = 'wendu'"
            class="data_card"
            style="background: #663333"
            :class="{ active: tp == 'wendu' }"
          >
            <div class="tp">温度</div>
            <div class="data_num">{{ currData.wendu | toInt }}</div>
            <span class="un">℃</span>
          </div>
        </van-col>

        <van-col span="8">
          <div
            @click="tp = 'pm10'"
            class="data_card"
            style="background: #26774f"
            :class="{ active: tp == 'pm10' }"
          >
            <div class="tp">PM10</div>
            <div class="data_num">{{ currData.pm10 }}</div>
            <span class="un">ug/m3</span>
          </div>
        </van-col>

        <van-col span="8">
          <div
            @click="tp = 'wind_direction'"
            class="data_card"
            style="background: #669999"
            :class="{ active: tp == 'wind_direction' }"
          >
            <div class="tp">风向</div>
            <div v-show="!currData.wind_direction" class="data_num">--</div>
            <img
              v-show="currData.wind_direction"
              style="margin-top: 5px"
              src="static/icon/wind.png"
              :style="{
                transform: 'rotate(' + currData.wind_direction + 'deg)',
              }"
            />
            <!-- <span class="un">°</span> -->
          </div>
        </van-col>

        <van-col span="8">
          <div
            @click="tp = 'shidu'"
            class="data_card"
            style="background: #989877"
            :class="{ active: tp == 'shidu' }"
          >
            <div class="tp">湿度</div>
            <div class="data_num">{{ currData.shidu | toInt }}</div>
            <span class="un">%RH</span>
          </div>
        </van-col>
      </van-row>

      <van-row
        gutter="10"
        style="
          margin: 10px auto 0px auto;
          text-align: center;
          padding-left: 10px;
          padding-right: 10px;
        "
        v-show="currData.station_param != '六参数'"
      >
        <van-col span="6" v-for="item in option_data_type" :key="item.value">
          <div
            @click="selectSensortype(item.value)"
            class="data_card"
            style="background: #73b973"
            :class="{ active: tp.includes(item.value) }"
          >
            <div class="tp">{{ item.label }}</div>
            <div class="data_num">
              {{ $sensortypeRound(item.value, currData[item.value]) }}
            </div>
            <span v-if="item.value !== 'wind_direction'" class="un">{{
              item.unit
            }}</span>
            <img
              v-if="item.value === 'wind_direction'"
              style="width: 20px"
              src="static/icon/wind.png"
              :style="{
                transform:
                  'rotate(' + currData.wind_direction + item.unit + ')',
              }"
            />
          </div>
        </van-col>
      </van-row>

      <!-- <div style="font-size: 12px;margin-bottom: 5px;text-align: center;">数据更新时间:{{currData.time2}}</div> -->
      <div style="text-align: left; padding: 6px">
        <el-radio-group size="small" v-model="timep">
          <el-radio-button label="min">实时</el-radio-button>
          <el-radio-button label="hour">时均</el-radio-button>
          <el-radio-button label="day">日均</el-radio-button>
          <el-radio-button label="week">周均</el-radio-button>
          <el-radio-button label="month">月均</el-radio-button>
          <!-- <el-radio-button label="year">年均</el-radio-button> -->
        </el-radio-group>
        <br />
        <!-- <div style="margin: 10px 0px 10px;">
          <span >对比:</span>
          <el-select size="small" v-model="back" placeholder="请选择" style="width: 130px">
            <el-option
              v-for="item in selectBack"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div> -->
      </div>
      <div class="block" style="text-align: left; padding: 6px">
        <el-date-picker
          popper-class="any_time"
          v-model="time_range"
          size="mini"
          :type="
            ['min', 'hour'].includes(timep)
              ? 'datetimerange'
              : ['day', 'week'].includes(timep)
              ? 'daterange'
              : 'monthrange'
          "
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="responsive-datepicker"
          :clearable="false"
          :editable="false"
          @change="change_datetime"
          @focus="preventPopUpKeyboardOnFocus"
        >
        </el-date-picker>
      </div>
      <div class="block" style="text-align: left; padding: 6px">
        <el-radio-group
          size="small"
          v-model="time_range_option"
          @change="change_time_range_option"
        >
          <el-radio-button v-if="timep === 'min'" label="nearly_3hour"
            >近3小时</el-radio-button
          >
          <el-radio-button v-if="timep === 'min'" label="nearly_12hour"
            >近12小时</el-radio-button
          >
          <el-radio-button v-if="timep === 'min'" label="nearly_24hour"
            >近24小时</el-radio-button
          >
          <el-radio-button v-if="timep === 'hour'" label="nearly_1day"
            >最近1天</el-radio-button
          >
          <el-radio-button v-if="timep === 'hour'" label="nearly_3day"
            >最近3天</el-radio-button
          >
          <el-radio-button v-if="timep === 'hour'" label="nearly_1week"
            >最近7天</el-radio-button
          >
          <el-radio-button v-if="timep === 'day'" label="nearly_1week"
            >最近1周</el-radio-button
          >
          <el-radio-button v-if="timep === 'day'" label="nearly_1month"
            >最近1月</el-radio-button
          >
          <el-radio-button v-if="timep === 'week'" label="nearly_1month"
            >最近1月</el-radio-button
          >
          <el-radio-button v-if="timep === 'week'" label="nearly_3month"
            >最近3月</el-radio-button
          >
          <el-radio-button v-if="timep === 'month'" label="nearly_3month"
            >最近3月</el-radio-button
          >
          <el-radio-button v-if="timep === 'month'" label="nearly_6month"
            >最近半年</el-radio-button
          >
          <!-- <el-radio-button label="year">年均</el-radio-button> -->
        </el-radio-group>
      </div>
      <div
        v-show="loadChart"
        class="ui active inverted dimmer"
        style="
          position: absolute;
          width: 100%;
          border: none;
          height: 290px;
          margin-top: 377px;
        "
      >
        <div class="ui text loader">加载中</div>
      </div>
      <div style="height: 290px" :id="id" :option="option"></div>
      <!-- <div id="morris-bar-chart" style="width:100%;">
        
      </div>-->
    </div>
  </div>
</template>

<script>
import HighCharts from "highcharts";
import { Toast, Dialog } from "vant";
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import { waterTypes } from "../../option/option.js";

function valueFormat(v) {
  if (v) {
    if (v > 100) {
      v = parseInt(v);
    } else {
      v = parseInt(v * 100) / 100;
    }
  }
  return v;
}

export default {
  name: "wxtest",
  data() {
    return {
      moment,
      msg: "Welcome to Your Vue.js App",
      tp: [],
      timep: "min",
      id: "test",
      sn: "",
      lng: "",
      lat: "",
      gfInfo: "",
      snInfo: { path: { name4: "" } },
      currData: {
        pm25: "",
        pm10: "",
        wind_speed: "",
        wind_direction: "",
        wendu: "",
        shidu: "",
        time2: "",
      },
      gfData: [],
      headText: "",
      start_t: "",
      end_t: "",
      time_range: "",
      time_range_option: "nearly_3hour",
      t: "",
      update_time: "",
      loadChart: false,
      setID: "",
      snData: [],
      anotherData: [],
      chart: "",
      //   typeDict:{pm25:'PM2.5', pm10:'PM10', wind_speed:'风速', wind_direction:'风向', wendu:'温度', shidu:'湿度'},
      typeIdx: {
        pm25: 1,
        pm10: 2,
        wendu: 3,
        shidu: 4,
        noise: 5,
        wind_speed: 6,
        wind_direction: 7,
      },
      selectBack: [
        // {value: 'city',label: '城市均值'},
        { value: "near1", label: "最近1km均值" },
        { value: "near3", label: "最近3km均值" },
        { value: "near5", label: "最近5km均值" },
      ],
      back: "near5",
      series: [],
      option: {
        title: { text: "" },
        subtitle: { text: "" },
        credits: {
          enabled: false, // 禁用版权信息
        },
        plotOptions: {
          series: {
            states: {
              inactive: {
                opacity: 1,
              },
            },
            connectNulls: true,
          },
        },
        xAxis: {
          type: "datetime",
          dateTimeLabelFormats: {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%m-%d",
            week: "%m-%d",
            month: "%Y-%m",
            year: "%Y",
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          min: 0,
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          dateTimeLabelFormats: {
            second: "%Y-%m-%d %H:%M:%S",
            minute: "%Y-%m-%d %H:%M:%S",
            hour: "%Y-%m-%d %H:%M:%S",
            day: "%Y-%m-%d %H:%M:%S",
            week: "%Y-%m-%d %H:%M:%S",
            month: "%Y-%m-%d %H:%M:%S",
            year: "%Y-%m-%d %H:%M:%S",
          },
          formatter: function () {
            let str = "";
            let p = this.points[0];

            str = moment(p.x - 3600 * 8 * 1000).format("YYYY-MM-DD HH:mm");
            str += "<br>";
            for (let item of this.points) {
              let data_type = item.point.series.userOptions.data_type;
              console.log(data_type);
              str += `<span style="color:${item.color}">${
                item.series.name
              }</span> : <span>${colorIntensity.sensortypeRound(
                data_type,
                item.y
              )} ${
                colorIntensity.getSensorDataInfo(data_type).unit
                // _page_config.sensortypes.find(x => x.value == data_type).unit
              }</span><br>`;
            }
            return str;
          },
        },
        series: [],
        responsive: {
          rules: [
            {
              condition: { maxWidth: 500 },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      },
    };
  },
  filters: {
    e(str) {
      if (str) {
        if (str > 100) {
          return parseInt(str);
        }
        return str.toFixed(1);
      } else {
        return "--";
      }
    },
    toInt(v) {
      if (v) {
        return parseInt(v);
      } else {
        return "--";
      }
    },
    f(s) {
      if (s) {
        return s.split(".")[0];
      } else {
        return "";
      }
    },
    head_title(v) {
      if (v) {
        if (v.length > 12) {
          return v.slice(0, 12) + "...";
        }
      } else {
        return v;
      }
    },
  },
  mounted() {
    this.initall();
  },
  watch: {
    timep() {
      console.log("timep--");
      this.getTime();
      this.getSnData();
    },
    tp() {
      console.log("tp--");
      this.getSnData();
    },
    stations() {
      for (var i in this.stations) {
        if (this.stations[i].path.DevSN == this.sn) {
          this.snInfo = this.stations[i];
        }
      }
    },
    back() {
      // this.changeBack();
    },
    $route(to, from) {
      if (to.name == "detailData" && from.name == "rank") {
        // this.back = "near5";
        this.initall();
      }
    },
  },
  computed: {
    ...mapState(["stations", "city_station_id", "hideBackBtn"]),
    ...mapGetters(["option_data_type"]),
    typeDict() {
      let typeObj = {};
      this.option_data_type.forEach((item) => {
        typeObj[item.value] = item.label;
      });
      return typeObj;
    },
    chartIds() {
      let ids = [];

      this.option_data_type.forEach((item) => {
        ids.push(`near_1_${item.value}`);
        ids.push(`near_3_${item.value}`);
        ids.push(`near_5_${item.value}`);
      });
      return ids;
    },
  },
  methods: {
    initall() {
      var { sn, lng, lat, data_type, timep, update_time, endTimePar } =
        this.$route.params;
      this.sn = sn;
      this.lng = lng;
      this.lat = lat;
      this.tp = [data_type];
      this.timep = timep;
      this.endTimePar = endTimePar;
      for (var i in this.stations) {
        if (this.stations[i].path.DevSN == this.sn) {
          this.snInfo = this.stations[i];
        }
      }
      this.getTime();
      // this.getCurrData()
      // this.getSnData();
    },
    selectSensortype(type) {
      if (this.tp.includes(type)) {
        if (this.tp.length > 1) {
          this.tp = this.tp.filter((item) => item !== type);
        } else {
          return;
        }
      } else {
        this.tp.push(type);
      }
    },
    changeBack() {
      if (this.back == "near_gf") {
        this.getNearGfData();
      }
      if (this.back == "gf_avg") {
        this.getGfavg();
      }
      if (this.back == "near1") {
        this.getNearStationAvg(1000);
      }
      if (this.back == "near3") {
        this.getNearStationAvg(3000);
      }
      if (this.back == "near5") {
        this.getNearStationAvg(5000);
      }
      if (this.back == "city") {
        this.getCityData();
      }
    },
    getCityData() {
      if (!this.city_station_id) {
        return;
      }
      var self = this;
      let start = moment(this.start_t * 1000).format("YYYY-MM-DD HH:mm:ss");
      let end = moment(this.end_t * 1000).format("YYYY-MM-DD HH:mm:ss");
      let url = `wz/getStationDataTimeSlot?time_type=${this.timep}&station_id=${this.city_station_id}&start_time=${start}&end_time=${end}&alltype=1&air_type=1`;

      // var url = "yc2/getStationHistory?timetype="+this.t+"&station_sn=FFFF-FF29&startTime="+this.start_t+"&endTime="+this.end_t+"&sensortypes=pm25,pm10,wendu,shidu,noise,wind_speed,wind_direction"
      axios_base
        .get(url)
        .then(function (resp) {
          var data = resp.data.values;
          if (!data || data.length === 0) {
            Toast("无数据");
          }
          var columns = resp.data.columns;
          var index = columns.indexOf(self.tp);
          var seriesData = [];
          for (var i in data) {
            var v = data[i][index];
            v = valueFormat(v);
            seriesData.push([(data[i][0] + 3600 * 8) * 1000, v]);
          }
          self.anotherData = {
            name: "城市均值",
            data: seriesData,
            color: "rgba(2, 2, 2, 0.48)",
            zIndex: 1,
            marker: {
              symbol: "circle",
            },
          };
          self.addAnotherSeries();
        })
        .catch(function (e) {
          console.log(e);
          self.anotherData = {
            name: "城市均值",
            data: [],
            color: "rgba(2, 2, 2, 0.48)",
            zIndex: 1,
          };
          self.addAnotherSeries();
        });
    },
    getNearByGF() {
      var self = this;
      axios
        .get(
          "http://api.novaecs.com/getNearbyGFStation.php?lat=" +
            this.lat +
            "&lng=" +
            this.lng
        )
        .then(function (resp) {
          self.gfInfo = resp.data.data[0];
          self.getGfData();
        });
    },
    addAnotherSeries() {
      for (let id of this.chartIds) {
        const s = this.chart.get(id);
        s && s.remove();
      }

      this.anotherData.forEach((series) => {
        this.chart.addSeries(series, false);
      });
      this.chart.redraw();
    },
    getNearStationAvg(dist = 1000) {
      var self = this;

      var url =
        "yc2/getNearStationAvg?lng=" +
        this.lng +
        "&lat=" +
        this.lat +
        "&sn=" +
        this.sn +
        "&round=" +
        dist +
        "&timep=" +
        this.timep;
      url += `&start_t=${this.start_t}&end_t=${this.end_t}`;
      axios_base
        .get(url)
        .then(function (resp) {
          var data = resp.data.data;
          if (!data || data.length === 0) {
            Toast(`最近${dist / 1000}km均值无数据`);
            self.anotherData = [];
            self.addAnotherSeries();
            return;
          }
          let series = [];
          for (let type of self.tp) {
            var seriesData = [];
            for (var i in data) {
              var v = data[i][type];
              v = valueFormat(v);
              seriesData.push([data[i].time, v]);
            }
            series.push({
              id: `near_${dist / 1000}_${type}`,
              name:
                "最近" +
                dist / 1000 +
                "km均值(" +
                resp.data.sninfo.length +
                "):" +
                self.typeDict[type],
              data: seriesData,
              data_type: type,
              zIndex: 1,
              marker: {
                symbol: "circle",
              },
            });
          }
          self.anotherData = series;
          self.addAnotherSeries();
        })
        .catch(function (e) {
          console.log(e);
          self.anotherData = {
            name: "最近" + dist / 1000 + "km均值",
            data: [],
            color: "rgba(2, 2, 2, 0.48)",
            zIndex: 1,
          };
          self.addAnotherSeries();
        });
    },
    getNearGfData() {
      var self = this;
      axios
        .get(
          "http://api.novaecs.com/getNearbyGFStation.php?lat=" +
            this.lat +
            "&lng=" +
            this.lng
        )
        .then(function (resp) {
          self.gfInfo = resp.data.data[0];
          var namegf = self.gfInfo.station + ":" + self.typeDict[self.tp];
          axios
            .get(
              "http://yc.novaecs.com/db/wpapi/api/v1/wp/getDataFromInfluxdb?start=" +
                self.start_t +
                "&end=" +
                self.end_t +
                "&sn=" +
                self.gfInfo.sid +
                "&pres=" +
                self.t +
                "&type=" +
                self.tp +
                "&tb=sensor_data_gf"
            )
            .then(function (resp) {
              self.gfData = resp.data[0].values;

              for (var i in self.gfData) {
                self.gfData[i][0] = self.gfData[i][0] * 1000;
              }
              self.anotherData = {
                name: namegf,
                data: self.gfData,
                color: "rgba(2, 2, 2, 0.48)",
                zIndex: 1,
              };
              self.addAnotherSeries();
            })
            .catch(function (e) {
              console.log(e);
              self.anotherData = {
                name: namegf,
                data: [],
                color: "rgba(2, 2, 2, 0.48)",
                zIndex: 1,
              };
              self.addAnotherSeries();
            });
        });
    },
    getGfavg() {
      var self = this;
      if (this.timep == "min") {
        self.anotherData = {
          name: "官方站均值",
          data: [],
          color: "rgba(2, 2, 2, 0.48)",
          zIndex: 1,
        };
        self.addAnotherSeries();
        return;
      }
      axios
        .get("http://p.jngrid.novaecs.com/api/yc2/getGfAvg?timep=" + this.timep)
        .then(function (resp) {
          var data = resp.data;
          if (!data || data.length === 0) {
            Toast("官方站均值无数据");
          }
          var seriesData = [];
          for (var i in data) {
            var v = data[i][self.tp];
            v = valueFormat(v);
            seriesData.push([data[i].time, v]);
          }
          self.anotherData = {
            name: "官方站均值",
            data: seriesData,
            color: "rgba(2, 2, 2, 0.48)",
            zIndex: 1,
          };
          self.addAnotherSeries();
        })
        .catch(function (e) {
          console.log(e);
          self.anotherData = {
            name: "官方站均值",
            data: [],
            color: "rgba(2, 2, 2, 0.48)",
            zIndex: 1,
          };
          self.addAnotherSeries();
        });
    },
    getTime() {
      // var end_t = Date.parse(new Date()) / 1000;
      var end_t = this.endTimePar / 1000;
      var start_t;
      var t = "1m";
      if (this.timep == "hour") {
        t = "1h";
        start_t = moment.unix(end_t).startOf('day').subtract(1, 'days').unix();
        this.time_range_option = "nearly_1day";
      } else if (this.timep == "day") {
        t = "1d";
        start_t = moment.unix(end_t).startOf('day').subtract(7, 'days').unix();
        this.time_range_option = "nearly_1week";
      } else if (this.timep == "min") {
        var end_t = Date.parse(new Date()) / 1000;
        start_t = moment.unix(end_t).startOf('hour').subtract(3, 'hours').unix();
        this.time_range_option = "nearly_3hour";
      } else if (this.timep == "week") {
        start_t = moment.unix(end_t).startOf('week').subtract(1, 'months').unix();
        this.time_range_option = "nearly_1month";
      } else if (this.timep == "month") {
        start_t = moment.unix(end_t).startOf('month').subtract(3, 'months').unix();
        this.time_range_option = "nearly_3month";
      } else if (this.timep == "year") {
        start_t = moment.unix(end_t).startOf('year').subtract(3, 'years').unix();
        this.time_range_option = "nearly_3year";
      }
      this.start_t = start_t;
      this.end_t = end_t;
      this.t = t;
      this.time_range = [moment.unix(this.start_t), moment.unix(this.end_t)];
    },
    getSnData() {
      var self = this;
      // if(this.timep === 'year'){
      //   return false
      // }
      this.loadChart = true;
      let start = moment(this.start_t * 1000).format("YYYY-MM-DD HH:mm:ss");
      let end = moment(this.end_t * 1000).format("YYYY-MM-DD HH:mm:ss");
      let url = `wz/getStationDataTimeSlot?time_type=${this.timep}&station_id=${this.snInfo.station.ID}&start_time=${start}&end_time=${end}&alltype=1&air_type=1`;
      axios_base
        .get(url)
        .then(function (resp) {
          var data = resp.data.values;
          if (!data || data.length === 0) {
            Toast("站点暂无数据");
            self.currData = {};
            self.option.series = [];
            self.chart = HighCharts.chart(self.id, self.option);
            // self.changeBack();
            self.loadChart = false;
            return;
          }
          var columns = resp.data.columns;
          let series = [];
          for (let type of self.tp) {
            var seriesData = [];
            const index = columns.indexOf(type);
            for (var i in data) {
              var v = data[i][index];
              v = valueFormat(v);
              seriesData.push([(data[i][0] + 3600 * 8) * 1000, v]);
            }
            var name1 = self.snInfo.path.name4 + ":" + self.typeDict[type];
            series.push({
              name: name1,
              data: seriesData,
              data_type: type,
              zIndex: 2,
              marker: {
                symbol: "circle",
              },
            });
          }
          self.snData = series;
          self.option.series = self.snData;
          self.chart = HighCharts.chart(self.id, self.option);
          // self.changeBack();
          self.loadChart = false;
          if (data.length) {
            let last_data = data[data.length - 1];
            let currData = {};
            let idx = 0;
            for (let c of columns) {
              let val = last_data[idx];
              if (val) {
                val = Math.round(val * 100) / 100;
              }
              currData[c] = val;
              idx++;
            }
            self.currData = currData;
          }
        })
        .catch(function (e) {
          self.loadChart = false;
          self.option.series = [{ name: self.tp, data: [] }];
          HighCharts.chart(self.id, self.option);
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    change_datetime() {
      this.time_range_option = null;
      this.start_t = this.time_range[0].getTime() / 1000;
      this.end_t = this.time_range[1].getTime() / 1000;
      this.getSnData();
    },
    change_time_range_option(option) {
      this.end_t = this.endTimePar / 1000;
      switch (option) {
        case "nearly_3hour":
          this.start_t = moment.unix(this.end_t).startOf('hour').subtract(3, 'hours').unix();
          break;
        case "nearly_12hour":
          this.start_t = moment.unix(this.end_t).startOf('hour').subtract(12, 'hours').unix();
          break;
        case "nearly_24hour":
          this.start_t = moment.unix(this.end_t).startOf('hour').subtract(24, 'hours').unix();
          break;
        case "nearly_1day":
          this.start_t = moment.unix(this.end_t).startOf('day').subtract(1, 'days').unix();
          break;
        case "nearly_3day":
          this.start_t = moment.unix(this.end_t).startOf('day').subtract(3, 'days').unix();
          break;
        case "nearly_1week":
          this.start_t = moment.unix(this.end_t).startOf('day').subtract(7, 'days').unix();
          break;
        case "nearly_1month":
          this.start_t = moment.unix(this.end_t).startOf('week').subtract(1, 'months').unix();
          break;
        case "nearly_3month":
          this.start_t = moment.unix(this.end_t).startOf('month').subtract(3, 'months').unix();
          break;
        case "nearly_6month":
          this.start_t = moment.unix(this.end_t).startOf('month').subtract(6, 'months').unix();
          break;
      }
      this.time_range = [moment.unix(this.start_t), moment.unix(this.end_t)];
      this.getSnData();
    },
    // 阻止弹出键盘
    preventPopUpKeyboardOnFocus() {
      // 设置日期组件内部的两个input
      let elDatePickers = null;
      elDatePickers = document.querySelectorAll(
        "body > div.el-picker-panel.el-date-range-picker.el-popper.has-time > div.el-picker-panel__body-wrapper > div > div.el-date-range-picker__time-header > span > span > div.el-date-range-picker__editor > input"
      );
      if (elDatePickers.length > 0) {
        elDatePickers.forEach((elDatePicker) => {
          elDatePicker.onfocus = () => {
            elDatePicker.blur();
          };
        });
        return;
      }
      setTimeout(() => {
        elDatePickers = document.querySelectorAll(
          "body > div.el-picker-panel.el-date-range-picker.el-popper.has-time > div.el-picker-panel__body-wrapper > div > div.el-date-range-picker__time-header > span > span > div.el-date-range-picker__editor > input"
        );
        elDatePickers.forEach((elDatePicker) => {
          elDatePicker.onfocus = () => {
            elDatePicker.blur();
          };
        });
      }, 200);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.data_card {
  height: 80px;
  border-radius: 5px;
  cursor: pointer;
  padding-top: 5px;
}
.active {
  border: 2px solid;
  box-sizing: border-box;
  height: 85px;
}
.data_num {
  color: white;
  font-size: 25px;
  margin: 4px 0;
}
.un {
  color: white;
  font-size: 12px;
}
.tp {
  color: #e0e0e0;
  font-size: 14px;
}
.van-col {
  margin-bottom: 5px;
}
.btn_active {
  background-color: #72d893;
}

.responsive-datepicker {
  width: 85%;
}
</style>
<style lang="less">
/* 适配手机屏幕 */
// @media (max-width: 768px) {
/* .el-date-picker {
    font-size: 0.75rem;
    padding: 5px;
  } */

// .el-picker-panel,
// .el-date-range-picker {
//   min-width: 100% !important;
//   left: 0 !important;
//   line-height: 29px;
// }
// .el-picker-panel_body {
//   min-width: 100%;
/* width: 90vw !important;
    left: 50% !important;
    transform: translateX(-50%) !important; */
//   }

//   .el-date-range-picker__content {
//     width: 100% !important;
//     float: none !important;
//   }

//   .el-picker-panel__footer .el-picker-panel__link-btn {
//     padding: 10px 20px;
//     font-size: 16px;
//   }
// }

.any_time > .el-picker-panel__body-wrapper > .el-picker-panel__body {
  min-width: 100%;
}
.any_time > .el-picker-panel__body-wrapper,
.any_time > .el-picker-panel__body-wrapper > .el-picker-panel__body,
.any_time
  > .el-picker-panel__body-wrapper
  > .el-picker-panel__body
  > .el-date-range-picker__time-header {
  width: 100%;
}
.any_time {
  width: 100% !important;
  left: 0;
  .el-date-range-picker__header > div {
    width: calc(100% - 40px);
    text-align: center;
    font-size: 0.75rem;
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .el-date-range-picker__header > div {
    width: calc(100% - 40px);
    text-align: center;
    font-size: 0.75rem;
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .el-date-range-picker__content > .el-date-table td span {
    width: 1.25rem;
    height: 1.25rem;
    line-height: 1.25rem;
  }
  .el-date-range-picker__content > .el-month-table td .cell {
    width: 2.25rem;
    height: 2.25rem;
    line-height: 2.25rem;
  }
  .el-date-range-picker__time-picker-wrap > .el-time-panel {
    width: 100%;
  }
  .el-date-range-picker__time-picker-wrap > .el-time-panel .el-time-panel__btn {
    padding: 0;
  }
  .el-date-range-picker__editor > .el-input__inner {
    padding: 0 0.1rem;
  }
  .el-time-panel__content {
    li {
      display: list-item;
    }
  }
  .el-picker-panel__footer .el-button--text {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/detailData.vue